import { ImageProps } from "@lib/image";
import { MDXRemoteSerializeResult } from "next-mdx-remote";
import {
  StrapiConditionDTO,
  ConditionDTO,
} from "@lib/strapi/dtos/content-types/condition.dto";
import { StrapiMediaDTO } from "@lib/strapi/dtos/core/media.dto";
import {
  StrapiSEODTO,
  SEODTO,
} from "@lib/strapi/dtos/components/shared/sEO.dto";

export class StrapiTreatmentDTO {
  constructor() {}

  title: string;
  slug: string;
  teaser: string;
  description: string;
  sortIndex: number;
  coverImage: StrapiMediaDTO;
  gallery: StrapiMediaDTO[];
  featuredInHomepageHero: boolean;
  featuredInHomepageCarousel: boolean;
  featuredHomepageHeroText: string;
  conditions: StrapiConditionDTO[];
  seo: StrapiSEODTO;
}

export class TreatmentDTO {
  constructor() {}

  extraData: any = {};
  title: string;
  slug: string;
  teaser: string;
  description: MDXRemoteSerializeResult;
  sortIndex: number;
  coverImage: ImageProps;
  gallery: ImageProps[];
  featuredInHomepageHero: boolean;
  featuredInHomepageCarousel: boolean;
  featuredHomepageHeroText: string;
  conditions: ConditionDTO[];
  seo: SEODTO;
}
